import request from '@/utils/request'

export function getData(data) {
  return request({
    url: '/sale-detail',
    method: 'post',
    data
  })
}

export function getData2(data) {
  return request({
    url: '/sale-detail/specilorg',
    method: 'post',
    data
  })
}

export function getDataPrice(data) {
  return request({
    url: '/sale-detail/with-price',
    method: 'post',
    data
  })
}

export function getDataPrice2(data) {
  return request({
    url: '/sale-detail/with-price/specilorg',
    method: 'post',
    data
  })
}

export function getExport(data) {
  return request({
    url: '/sale-detail/export',
    method: 'post',
    data
  })
}

export function getExport2(data) {
  return request({
    url: '/sale-detail/export/specilorg',
    method: 'post',
    data
  })
}

export function getExportPrice(data) {
  return request({
    url: '/sale-detail/export-price',
    method: 'post',
    data
  })
}

export function getExportPrice2(data) {
  return request({
    url: '/sale-detail/export-price/specilorg',
    method: 'post',
    data
  })
}

export function getStore(params) {
  return request({
    url: '/store-detail',
    method: 'get',
    params
  })
}

export function getStore2(params) {
  return request({
    url: '/store-detail/specilorg',
    method: 'get',
    params
  })
}

export function getStoreExport(params) {
  return request({
    url: '/store-detail/export',
    method: 'get',
    params
  })
}

export function getStoreExport2(params) {
  return request({
    url: '/store-detail/export/specilorg',
    method: 'get',
    params
  })
}

export function artSearch(query) {
  return request({
    url: '/article/user-art',
    method: 'get',
    params: { query }
  })
}

export function billtypeSearch(query) {
  return request({
    url: '/billtype/user-billtype',
    method: 'get',
    params: { query }
  })
}

export function getProductInfo(bseqid) {
  return request({
    url: '/productinfo',
    method: 'get',
    params: { bseqid }
  })
}

export function getDzjgm(code,artid) {
  return request({
    url: '/productinfo/dzjgm',
    method: 'get',
    params: { code,artid }
  })
}

export function getFlowImport(params) {
  
  return request({
    url: '/productinfo/getflowimport',
    method: 'get',
    params
  })
}

export function selectCustList(custname) {
  
  return request({
    url: '/productinfo/selectCustList',
    method: 'get',
    params: { "custname":custname }
  })
}

export function saveFlow(params) {
  
  return request({
    url: '/productinfo/flowSave',
    method: 'post',
    params
  })
}

export function deleteFlow(id) {
  return request({
    url: '/productinfo/deleteFlow?id='+id,
    method: 'post',
    param:{}
  })
}


export function selectProductList(params) {
  
  return request({
    url: '/productadd/getProductlist',
    method: 'post',
    params:{
      'page': params.page,
      'limit': params.limit,
      'asc': params.asc,
      'productname':params.productname, 
      'factory':params.factory,
      'dirfrom':params.dirfrom.join(','),
      'dirproperty':params.dirproperty.join(','),
      'ybtype':params.ybtype.join(','),
      'consistency':params.consistency, 
      'jiming': params.jiming,
      'lpz':params.lpz 
    }
  })
}

export function saveProduct(params) {
  
  return request({
    url: '/productadd/productSave',
    method: 'post',
    params
  })
}

export function deleteProduct(id) {
  return request({
    url: '/productadd/deleteProduct?id='+id,
    method: 'post',
    param:{}
  })
}

export function getcode(tel) {
  
  return request({
    url: '/user/getcode',
    method: 'get',
    params: { "tel":tel }
  })
}

export function reg(params) {
  return request({
    url: '/user/reg',
    method: 'post',
    params
  })
}







